import React from 'react';
import GoogleMapReact from 'google-map-react';
import * as webpageStyles from "./webpageStyles.jsx"
import * as webpageTools from "./webpageTools.jsx"

import * as visualAssets from './../visualAssets.jsx';

import {ExploreMap} from "./../ExploreMap.jsx";
import * as mapStyles from "./../styles/mapStyles";

const testCompositions =
[
   {position:{lng:11, lat:54}},
   {position:{lng:10, lat:51}},
   {position:{lng:51, lat:10}},
   {position:{lng:50, lat:11}},
]

var mapOptions = {
   overviewMapControl: false,
   streetViewControl: false,
   rotateControl: true,
   //mapTypeControl: true,
   //mapTypeId:"satellite",
   // disable poi
   //styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
   //minZoom: DEFAULT_MIN_ZOOM, // dynamically recalculted if possible during init
   }


const mapDefaultCenter = {lat: 59.95, lng: 30.33};
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const vimeoHubnutUrl = "https://player.vimeo.com/hubnut/channel/1220108?color=44bbff&amp;background=000000&amp;slideshow=1&amp;video_title=1&amp;video_byline=1";
const vimeoUrl = isIOS ? "https://player.vimeo.com/video/209193263" : vimeoHubnutUrl;

const vimeoLink = "https://vimeo.com/209225512";

const appStoreStyle = {
   display:"block",
   overflow:"hidden",
   background:visualAssets.appStoreIconUrl,
   backgroundRepeat: "no-repeat",
   width:"20vw",
   height:"6vw",
   maxWidth:200,
   maxHeight:60,
   backgroundSize:"contain",
   margin:"auto",
}

const googlePlayStyle = {
   display:"block",
   width:"23vw",
   //height:"7vw",
   maxWidth:230,
   margin:"auto",
   backgroundSize:"contain",
   backgroundRepeat: "no-repeat"
}

export class Oplevelse extends React.Component {
   
   constructor(props)
   {
      super(props);
      
      this.state =
      {
         windowWidth:window.innerWidth,
      }
      this.reactToResize = () =>
      {
       this.setState({windowWidth:window.innerWidth});
      }
      
      this.reactToResize.bind(this);

      
   }


   setText1(text)
   {
      this.text1 = text;
      this.forceUpdate();
   }

   setText2(text)
   {
      this.text2 = text;
      this.forceUpdate();
   }

   setText3(text)
   {
      this.text3 = text;
      this.forceUpdate();
   }

   setVimeoEmbed(text)
   {
      this.vimeoEmbed = text;
      this.forceUpdate();
   }
   componentWillMount()
   {
      this.text1 = "";
      this.text2 = "";
      this.text3 = "";

      webpageTools.getTextFileAsString("oplevelse1.txt", this.setText1.bind(this));
      webpageTools.getTextFileAsString("oplevelse2.txt", this.setText2.bind(this));
      webpageTools.getTextFileAsString("oplevelse3.txt", this.setText3.bind(this));

      window.addEventListener("resize", this.reactToResize);
   }
	componentWillUnmount()
   {
      window.removeEventListener("resize", this.reactToResize);
   }

   render() {
    

      const showVideoRight = this.state.windowWidth >= 850;

      const leftColCotainer = showVideoRight ? webpageStyles.leftColumnContainer : webpageStyles.leftColumnContainerMobile;
      const rightColCotainer = showVideoRight ? webpageStyles.rightColumnOuterContainer : webpageStyles.rightColumnOuterContainerMobile;
 
      return (
         <div style={webpageStyles.outerContainer}>
            <div style={leftColCotainer}>
               <div dangerouslySetInnerHTML={{__html: this.text1}} className={"textColumn"}/>
               <div style={showVideoRight ? webpageStyles.hideStyle : webpageStyles.leftColBox}>
                  <iframe src={vimeoUrl} style={webpageStyles.vimeoIFrameLeft}
                     frameBorder={0} allowFullScreen={true} /*height={200} width={400}*//>
               </div>
               {!showVideoRight ? <p className={"elemComment"}>10 film.<br/>Jeg kan huske ® Skandinavien</p> : null}
               {/*<div dangerouslySetInnerHTML={{__html: this.text2}} className={"textColumn"}/>*/}
                <div style={showVideoRight ? webpageStyles.hideStyle : webpageStyles.mapBoxRight}>
                 <img src = {visualAssets.mapImg} style={{width:"100%"}}/>
               </div>
               {!showVideoRight ? <p className={"elemComment"}>30 lydhistorier.<br/>Jeg kan huske ® Skandinavien</p> : null}
               <div dangerouslySetInnerHTML={{__html: this.text3}} className={"textColumn"}/>
            </div>
            <div style={rightColCotainer}>
               {/*<img src={visualAssets.soundmapLogo} style={webpageStyles.soundmapLogo}/>*/}
               {/*<div style={{height:"3vw"}} />*/}
               <div style={showVideoRight ? webpageStyles.box : webpageStyles.hideStyle}>
                  <iframe src={vimeoUrl} style={webpageStyles.vimeoIFrameRight}
                     frameBorder={0} allowFullScreen={true}/*height={200} width={400}*//>
               </div>
               {showVideoRight ? <p className={"elemComment"}>10 film. (<a href={vimeoLink}>se på vimeo</a>)<br/>Jeg kan huske ® Skandinavien</p> : null}

               <div style={showVideoRight ? webpageStyles.mapBoxRight : webpageStyles.hideStyle}>
                 <img src = {visualAssets.mapImg} style={{width:"100%", cursor:"pointer"}} onClick={()=>{console.log("Click Map");this.props.goToMap();}}/>
               </div>
               {showVideoRight ? <p className={"elemComment"}>30 lydhistorier.<br/>Jeg kan huske ® Skandinavien</p> : null}
               
               {/*
               <a href={"https://itunes.apple.com/us/app/soundmap/id1218727645?ls=1&mt=8"} style={appStoreStyle}> </a>
               
               <div style={{display:"block", height:30}}/>
               <a href='https://play.google.com/store/apps/details?id=dk.soundmap.app&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                  <img style={googlePlayStyle} alt='Nu på Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/da_badge_web_generic.png'/>
               </a>
               <div style={{display:"block", height:30}}/>
               <div className={"elemComment"}>
                  <a>Ikonforklaring til App</a>
                  <br/>
                  <a style={{color:"#646463"}} href="Assets/Icon_list_soundmap.pdf" download>(Download pdf)</a>
               </div>
            */}
               
            </div>
         </div>
         
         );
   }
}


// WEBPACK FOOTER //
// ./js/webpages/oplevelse.jsx